import {
  VStack,
  HStack,
  Center,
  Box,
  Text,
  Pressable,
  PresenceTransition,
  Skeleton,
} from 'native-base';

// Assets
import { theme } from '@breakroom-nx/assets';
import { ChatAvatar } from '../chat-avatar/chat-avatar';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import {
  openChat,
  selectRoom,
  toggleChatRoomPanel,
  useAppSelector,
  getChatsPanelState,
  getChatRoomPanelState,
  toggleChatPanel,
} from '@breakroom-nx/redux';

// Classes & Types
import { Streak, Room, calculatePathColor } from '@breakroom-nx/classes';

import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { useEffect, useState } from 'react';

export interface ChatBubbleProps {
  room: Room;
  showStreak?: boolean;
  size?: string | number;
  showLastMessage?: boolean;
  disabled?: boolean;
}

export function ChatBubble({
  room,
  showStreak = false,
  size = '70px',
  showLastMessage = false,
  disabled = false,
}: ChatBubbleProps) {
  const streak = new Streak(room.streakDuration());

  // Redux
  const dispatch = useDispatch();

  // Panel Controls
  const chatsDisplayed = useAppSelector(getChatsPanelState);
  const chatRoomDisplayed = useAppSelector(getChatRoomPanelState);

  const renderStreak = () => {
    return showStreak ? (
      <Box position={'absolute'} bottom={'0px'} mb={-1}>
        <HStack
          alignItems={'center'}
          justifyContent={'center'}
          space={'2px'}
          bg={streak.getColor()}
          rounded={'full'}
          px={'4.5px'}
        >
          {streak.getIcon(
            streak.isExpiring() ? 'white' : theme.colors.primary[100],
            10
          )}
          <Text
            fontSize={12}
            fontWeight={600}
            color={streak.isExpiring() ? 'white' : theme.colors.primary[100]}
            lineHeight={16}
          >
            {streak.getDuration()}
          </Text>
        </HStack>
      </Box>
    ) : null;
  };

  return (
    <PresenceTransition
      visible={true}
      initial={{
        opacity: 0,
        scale: 0,
      }}
      animate={{
        opacity: 1,
        scale: 1,
        transition: {
          duration: 250,
        },
      }}
    >
      <Pressable
        disabled={disabled}
        onPress={() => {
          // dispatch(selectRoom(room));
          // // navigation.jumpTo('Chats', { screen: 'ChatRoom' });
          // dispatch(toggleChatRoomPanel());
          // if (!chatsDisplayed) {
          //   dispatch(toggleChatPanel());
          // }
          // if (!chatRoomDisplayed) {
          //   dispatch(toggleChatRoomPanel());
          // }
        }}
        _pressed={{ opacity: 0.8 }}
      >
        <VStack key={room.id}>
          <Center>
            <ChatAvatar room={room} size={size} />
            {/* {renderStreak()} */}
          </Center>
        </VStack>
      </Pressable>
    </PresenceTransition>
  );
}

// export default ChatBubble;

{
  /* <Skeleton
width={'65px'}
height={'65px'}
rounded="full"
startColor={theme.colors.surface[200]}
/> */
}
